
<script>
export default {
  name: 'SelfServiceRedirect',
  mounted() {
    if (this.$route.params.uid && this.$route.params.cid) {
      this.confirmCompany()
        .then(() => {
          this.init()
            .then(() => {
              this.$router.push('/search')
            })
        })
    }
  },
  methods: {
    async confirmCompany() {
      await this.$http.put(this.$appConfig.api.baseUrl + `user/${this.$route.params.uid}/companies/${this.$route.params.cid}/approve`)
    }
  }
}
</script>
